import { Loader2 } from 'lucide-react';

interface FormSubmitOverlayProps {
  open: boolean;
  title: string;
  description?: string;
}

export function FormSubmitOverlay({ open, title, description }: FormSubmitOverlayProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/70 backdrop-blur-sm">
      <div className="mx-4 w-full max-w-sm rounded-2xl border border-border/60 bg-card p-6 text-center shadow-xl shadow-primary/10">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <Loader2 className="h-7 w-7 animate-spin text-primary" />
        </div>
        <p className="text-base font-semibold text-foreground">{title}</p>
        {description ? (
          <p className="mt-1.5 text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
    </div>
  );
}
